(() => {
  'use strict';

  if (window.__ossLinkAuditFixesInstalled) return;
  window.__ossLinkAuditFixesInstalled = true;

  const internalPathFixes = new Map([
    ['/collections/liverpool', '/collections/liverpool-fc-jerseys'],
    ['/collections/bayern-munich', '/collections/fc-bayern-munich-jerseys'],
    ['/collections/barcelona', '/collections/fc-barcelona-jerseys'],
    ['/collections/nike-football-boots', '/collections/nike-football'],
    ['/collections/adidas-football-boots', '/collections/adidas-football'],
    ['/collections/puma-football-boots', '/collections/puma-football'],
    ['/collections/football-shirts', '/collections/soccer-jerseys'],
    ['/pages/contact', '/pages/customer-care']
  ]);

  const cleanText = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const setHref = (anchor, target) => {
    if (!anchor || !target || anchor.getAttribute('href') === target) return;
    anchor.setAttribute('href', target);
    anchor.dataset.ossLinkAuditFixed = 'true';
  };

  const rewriteInternalPath = (anchor) => {
    const rawHref = anchor.getAttribute('href');
    if (!rawHref || rawHref.startsWith('#') || rawHref.startsWith('mailto:') || rawHref.startsWith('tel:')) return;

    let url;
    try {
      url = new URL(rawHref, window.location.origin);
    } catch (_) {
      return;
    }
    if (url.origin !== window.location.origin) return;

    for (const [oldPath, newPath] of internalPathFixes) {
      if (url.pathname === oldPath || url.pathname.endsWith(oldPath)) {
        const localePrefix = url.pathname.slice(0, url.pathname.length - oldPath.length);
        url.pathname = localePrefix + newPath;
        setHref(anchor, url.pathname + url.search + url.hash);
        return;
      }
    }
  };

  const fixKnownTextLinks = (anchor) => {
    const text = cleanText(anchor.textContent);
    let path = '';
    try { path = new URL(anchor.getAttribute('href') || '#', window.location.origin).pathname; } catch (_) {}

    if (text === 'fanshop' && (path.endsWith('/collections/katar-worldcup-2022-jerseys') || path.endsWith('/collections/fanshop'))) {
      setHref(anchor, '/collections/soccer-jerseys');
      return;
    }

    if (text === 'football shirts') {
      setHref(anchor, '/collections/soccer-jerseys');
      return;
    }

    if (text === 'nike football boots') {
      setHref(anchor, '/collections/nike-football');
      return;
    }

    if (text === 'adidas football boots') {
      setHref(anchor, '/collections/adidas-football');
      return;
    }

    if (text === 'puma football boots') {
      setHref(anchor, '/collections/puma-football');
    }
  };

  const fixHomepage = () => {
    if (window.location.pathname !== '/' && !/^\/[a-z]{2}(?:-[a-z]{2})?\/?$/i.test(window.location.pathname)) return;

    document.querySelectorAll('.hero a').forEach((anchor) => {
      if (cleanText(anchor.textContent) === 'explore') setHref(anchor, '/pages/explorer');
    });

    document.querySelectorAll('a').forEach((anchor) => {
      const img = anchor.querySelector('img');
      const src = img ? String(img.currentSrc || img.src || '') : '';

      if (src.includes('nike-breakout-indexree.png')) {
        setHref(anchor, '/blogs/news/nike-breakout-pack-2026-football-boots');
      } else if (src.includes('real-9.jpg')) {
        setHref(anchor, '/collections/real-madrid-jerseys');
      } else if (src.includes('psg-2-1.jpg')) {
        setHref(anchor, '/blogs/news/paris-saint-germain-unveils-2026-27-home-jersey-1');
      } else if (src.includes('adimain-1.jpg')) {
        setHref(anchor, '/collections/adidas-football');
      } else if (src.includes('messi6-1.jpg')) {
        setHref(anchor, '/blogs/news/adidas-f50-messi-elite-fg-aurora-radiante-boots-unveiled');
      } else if (src.includes('Screenshot_2026-06-08_163640.png')) {
        setHref(anchor, '/collections/real-madrid-jerseys');
      }
    });

    document.querySelectorAll('.social-member-section .social-box a').forEach((anchor) => {
      const text = cleanText(anchor.textContent);
      if (text.startsWith('tiktok')) setHref(anchor, 'https://www.tiktok.com/@onesportystore');
      if (text.startsWith('instagram')) setHref(anchor, 'https://www.instagram.com/onesportystore/');
    });
  };

  const fixProductMetadataLinks = () => {
    const vendorLink = document.querySelector('.product-detail__vendor a');
    if (vendorLink) {
      const vendor = cleanText(vendorLink.textContent);
      if (vendor === 'adidas') setHref(vendorLink, '/collections/adidas-football');
      else if (vendor === 'nike') setHref(vendorLink, '/collections/nike-football');
      else if (vendor === 'puma') setHref(vendorLink, '/collections/puma-football');
    }

    const typeLink = document.querySelector('.type-wrapper__type');
    if (typeLink) {
      const type = cleanText(typeLink.textContent);
      if (type.includes('jersey') || type.includes('shirt')) setHref(typeLink, '/collections/soccer-jerseys');
      else if (type.includes('soccer cleat')) setHref(typeLink, '/collections/soccer-cleats');
      else if (type.includes('football boot')) setHref(typeLink, '/collections/football-boots');
    }
  };

  const apply = (root = document) => {
    if (root.querySelectorAll) {
      root.querySelectorAll('a[href]').forEach((anchor) => {
        rewriteInternalPath(anchor);
        fixKnownTextLinks(anchor);
      });
    }
    fixHomepage();
    fixProductMetadataLinks();
  };

  const init = () => {
    apply(document);
    let timer = null;
    new MutationObserver((mutations) => {
      if (!mutations.some((mutation) => mutation.addedNodes.length)) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(() => apply(document), 40);
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
